/** @jsxImportSource @emotion/react */
import OutlinedInput, { OutlinedInputProps } from '@mui/material/OutlinedInput'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'
import { forwardRef } from 'react'
import * as classes from './styles'

export type InputProps = Omit<OutlinedInputProps, 'value' | 'onChange'> & {
  value: string
  onChange: (value: string) => void
  formHelperText?: string
}

export const Input = forwardRef(
  ({ onChange, label, error, formHelperText, fullWidth, className, ...props }: InputProps, ref) => {
    const controlInput = <OutlinedInput onChange={(e) => onChange(e.target.value)} error={error} {...props} />

    return (
      <div className={className} css={classes.wrapper(fullWidth)}>
        {label ? (
          <FormControlLabel
            inputRef={ref}
            control={controlInput}
            label={label}
            labelPlacement="top"
            css={classes.labelWrapper}
          />
        ) : (
          controlInput
        )}
        {!!formHelperText && <FormHelperText error={error}>{formHelperText}</FormHelperText>}
      </div>
    )
  }
)

Input.displayName = 'Input'
